var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStoreLocatorWhite = function SvgStoreLocatorWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L17.691 0 17.691 20 0 20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.846 1.053c-4.287 0-7.775 3.428-7.775 7.641 0 3.714 6.26 8.907 7.775 10.108 1.514-1.202 7.775-6.397 7.775-10.108 0-4.213-3.488-7.641-7.775-7.641m0 18.947c-.115 0-.23-.036-.326-.11C8.172 19.63 0 13.412 0 8.695 0 3.9 3.97 0 8.846 0c4.878 0 8.845 3.9 8.845 8.694 0 4.717-8.171 10.935-8.52 11.197-.095.073-.21.11-.325.11",
    mask: "url(#prefix__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.416 9.58c0 .994-.82 1.801-1.833 1.801S6.75 10.574 6.75 9.58c0-.995.82-1.802 1.833-1.802 1.012 0 1.833.807 1.833 1.802"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoreLocatorWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/storeLocatorWhite.411c95e8.svg";
export { ForwardRef as ReactComponent };